import {AfterViewInit, Component, OnInit} from '@angular/core';
import {EChartsOption} from 'echarts';
import {ReportDashboardWidgetChartStore} from '../../../../../shared/store/report/report-dashboard-widget-chart.store';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-widget-chart',
  templateUrl: './widget-chart.component.html',
  styleUrls: ['./widget-chart.component.scss'],
  providers: [ReportDashboardWidgetChartStore]
})
export class WidgetChartComponent implements OnInit, AfterViewInit {
  public readonly chartOption$: Observable<EChartsOption> = this._reportDashboardWidgetChartStore.chartOption$

  constructor(
    private readonly _reportDashboardWidgetChartStore: ReportDashboardWidgetChartStore
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

}
